import $ from 'jquery';

// import script accordingly
import './themes/header/_header';
// import "./themes/header/_footer";
import './themes/form/_form';
import './themes/carousel/_carousel';
import './themes/copy/_copy';
